export * from './lib/ngrx-core.module';
